import { createContext } from "react";

import {
  BillingAddon,
  BillingAddonType,
  BillingPlan,
  BillingSubscription,
  BillingTier,
} from "types/generated";

type BillingContextValue = {
  tier: BillingTier;
  billedExternally: boolean;
  billingSubscription?: BillingSubscription;
  onTrialUntil?: number;
  isTrial: boolean;
  currentAddons: BillingAddonType[];
  availableBillingAddons: BillingAddon[];
  availableSelfServicePlans: BillingPlan[];
};

export const BillingContext = createContext<BillingContextValue | undefined>(undefined);
BillingContext.displayName = "BillingContext";
